// removed by extract-text-webpack-plugin
module.exports = {"CookieBanner":"src-components-CookieBanner----style-module---CookieBanner---v-A3l","visible":"src-components-CookieBanner----style-module---visible---16l6-","message":"src-components-CookieBanner----style-module---message---1n0YC","actions":"src-components-CookieBanner----style-module---actions---m6mbj","fakeUnderlinedLink":"src-components-CookieBanner----style-module---fakeUnderlinedLink---3jdow","line":"src-components-CookieBanner----style-module---line---1z8uj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieBanner/style.module.scss
// module id = 394
// module chunks = 114276838955818